import { useState, useEffect } from 'react'
import { supabase } from '../../supabase'
import { useAuth } from '../../contexts/AuthContext'
import { formatEuro, MOIS_LABELS } from '../../utils/calculs'

export default function RecapAnnuelSuperviseur() {
  const { profile } = useAuth()
  const now = new Date()
  const [annee, setAnnee] = useState(now.getFullYear())
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!profile) return
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [annee, profile])

  async function load() {
    setLoading(true)
    const { data: seances } = await supabase
      .from('seances')
      .select('date, pole, remuneration_affichee, total_massage_payant, total_massage_gratuit')
      .or(`superviseur_id.eq.${profile.id},superviseur2_id.eq.${profile.id}`)
      .gte('date', `${annee}-01-01`)
      .lte('date', `${annee}-12-31`)
      .order('date')
    setData(seances || [])
    setLoading(false)
  }

  // Grouper par mois
  const parMois = {}
  for (let m = 1; m <= 12; m++) {
    parMois[m] = { remuneration: 0, seances: 0, payants: 0, gratuits: 0 }
  }
  for (const s of data) {
    const m = new Date(s.date).getMonth() + 1
    const rem = s.partage_horaire ? (s.superviseur_id === profile.id ? (s.sup1_remuneration || 0) : (s.sup2_remuneration || 0)) : (s.remuneration_affichee || 0)
    parMois[m].remuneration += rem
    parMois[m].seances += 1
    parMois[m].payants += s.total_massage_payant || 0
    parMois[m].gratuits += s.total_massage_gratuit || 0
  }

  const totaux = {
    remuneration: data.reduce((a, s) => a + (s.partage_horaire ? (s.superviseur_id === profile.id ? (s.sup1_remuneration || 0) : (s.sup2_remuneration || 0)) : (s.remuneration_affichee || 0)), 0),
    seances: data.length,
    payants: data.reduce((a, s) => a + (s.total_massage_payant || 0), 0),
    gratuits: data.reduce((a, s) => a + (s.total_massage_gratuit || 0), 0),
  }

  const moisActifs = Array.from({ length: 12 }, (_, i) => i + 1).filter(m => parMois[m].seances > 0)
  const annees = [2023, 2024, 2025, 2026, 2027]

  return (
    <div className="me-page">
      <div className="me-header">
        <div className="me-header-name">{profile?.prenom} {profile?.nom}</div>
        <div className="me-header-role">Récapitulatif annuel</div>
      </div>

      <div className="me-filters" style={{marginBottom:20}}>
        <select value={annee} onChange={e => setAnnee(+e.target.value)} className="me-select">
          {annees.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
      </div>

      <div className="me-stats" style={{marginBottom:24}}>
        <div className="me-stat-main">
          <div className="me-stat-label">Total à facturer {annee}</div>
          <div className="me-stat-value">{formatEuro(totaux.remuneration)}</div>
          <div className="me-stat-sub">{totaux.seances} séance{totaux.seances > 1 ? 's' : ''}</div>
        </div>
        <div className="me-stats-secondary">
          <div className="me-stat">
            <div className="me-stat-label">Séances</div>
            <div className="me-stat-value-sm">{totaux.seances}</div>
          </div>
          <div className="me-stat">
            <div className="me-stat-label">Payants</div>
            <div className="me-stat-value-sm">{totaux.payants}</div>
          </div>
          <div className="me-stat">
            <div className="me-stat-label">Gratuits</div>
            <div className="me-stat-value-sm">{totaux.gratuits}</div>
          </div>
        </div>
      </div>

      {loading ? <div className="spinner" /> : (
        moisActifs.length === 0 ? (
          <div className="me-empty">Aucune séance en {annee}</div>
        ) : (
          <div className="me-seances">
            {moisActifs.map(m => (
              <div key={m} className="me-card">
                <div className="me-card-top">
                  <div className="me-card-date">
                    <span className="me-card-day">{MOIS_LABELS[m]} {annee}</span>
                    <span style={{fontSize:12, color:'var(--stone)'}}>
                      {parMois[m].seances} séance{parMois[m].seances > 1 ? 's' : ''}
                    </span>
                  </div>
                  <div className="me-card-montant">{formatEuro(parMois[m].remuneration)}</div>
                </div>
                <div className="me-card-soins">
                  <span className="me-soin-tag">{parMois[m].payants} soin{parMois[m].payants > 1 ? 's' : ''} payant{parMois[m].payants > 1 ? 's' : ''}</span>
                  {parMois[m].gratuits > 0 && (
                    <span className="me-soin-tag me-soin-tag-gratuit">{parMois[m].gratuits} gratuit{parMois[m].gratuits > 1 ? 's' : ''}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )
      )}

      {totaux.seances > 0 && (
        <div className="me-total">
          <span>Total {annee}</span>
          <strong>{formatEuro(totaux.remuneration)}</strong>
        </div>
      )}
    </div>
  )
}
